var styles = {"date":"styles_date__m0cLJ","today":"styles_today__V99hg","active":"styles_active__30OzF","ghost":"styles_ghost__tm-Zp"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
